"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numericTransform = void 0;
/**
 * Extract value from unary matcher data.
 */
function numericTransform(unaryNumericObject) {
    return unaryNumericObject.value;
}
exports.numericTransform = numericTransform;
